// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-container {
  background-color: white;
  border-color: transparent;
  height: 100vh;
  z-index: 20;
}

.transition-all {
  transition: all 0.3s ease-in-out;
}


.-translate-x-full {
  transform: translateX(-100%);
}

.box-shadow {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.sidebar-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  position: sticky;
  top: 0;
}

.sidebar-logo {
  display: flex;
  justify-content: center;
  padding-top: 16px;
}

.sidebar-nav {
  flex-grow: 1;
}

.sidebar-items {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.sidebar-item {
  border-radius: 50%;
  padding-top: 16px;
  margin: 0 5px;
  width: 30px;
  height: 30px;
}

.collapsed-item {
  margin: 0 auto;
}

.sidebar-link {
  display: flex;
  gap: 6px;
  align-items: center;
}

.text-label {
  display: inline-block;
  color: #787777;
}

.text-label:hover {
  color: #EB7D14
}

.sidebar-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
}

.toggle-button {
  display: flex;
  align-items: center;
  border: none;
  background: none;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/Sidebar-style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".sidebar-container {\n  background-color: white;\n  border-color: transparent;\n  height: 100vh;\n  z-index: 20;\n}\n\n.transition-all {\n  transition: all 0.3s ease-in-out;\n}\n\n\n.-translate-x-full {\n  transform: translateX(-100%);\n}\n\n.box-shadow {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  position: sticky;\n  top: 0;\n}\n\n.sidebar-logo {\n  display: flex;\n  justify-content: center;\n  padding-top: 16px;\n}\n\n.sidebar-nav {\n  flex-grow: 1;\n}\n\n.sidebar-items {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.sidebar-item {\n  border-radius: 50%;\n  padding-top: 16px;\n  margin: 0 5px;\n  width: 30px;\n  height: 30px;\n}\n\n.collapsed-item {\n  margin: 0 auto;\n}\n\n.sidebar-link {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.text-label {\n  display: inline-block;\n  color: #787777;\n}\n\n.text-label:hover {\n  color: #EB7D14\n}\n\n.sidebar-toggle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 16px 0;\n}\n\n.toggle-button {\n  display: flex;\n  align-items: center;\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
